// import { Logo } from '../logo';
import { styled } from '@mui/material/styles';
// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Button, Typography } from '../../../lib/base';

const RetryArea = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}));

const ReloadButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

const ButtonText = styled(Typography)(({ theme }) => ({
  color: theme.custom.colors.common.white,
}));

const Headline = styled(Typography)(({ theme }) => ({
  paddingBottom: theme.spacing(1),
  paddingTop: theme.spacing(1),
}));

const Root = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2),
  },
}));

interface Props {
  error?: Error;
  retry?: () => void;
}
export default function ErrorView({ error, retry }: Props): React.ReactElement {
  let content: React.ReactElement;
  if (retry != null) {
    content = (
      <RetryArea>
        <Typography variant="subtitle1">
          Try going back to where you were, refreshing the page, or clicking reload below.
        </Typography>
        <ReloadButton onClick={retry} variant="contained" color="primary">
          <ButtonText variant="body1">RELOAD</ButtonText>
        </ReloadButton>
      </RetryArea>
    );
  } else {
    let messageToUse = error?.message ?? 'Unknown Error.';
    if (!messageToUse.endsWith('.')) {
      messageToUse += '.';
    }
    content = (
      <Typography variant="subtitle1">{`${messageToUse} Try going back to where you were or refreshing the page.`}</Typography>
    );
  }
  return (
    <Root>
      {/* <Logo width={48} height={56} /> */}
      <Headline variant="h4">Something went wrong!</Headline>
      {content}
    </Root>
  );
}
